// Pop-up po přidání do košíku — doplnění VŠECH souvisejících produktů z detailu přidaného produktu.
// Shoptet v pop-upu ukazuje jen první 4 související. Zjistíme, odkud se přidávalo (karta / detail),
// stáhneme detail produktu a do swiperu doplníme karty, které v pop-upu ještě nejsou.

// Poslední formulář „do košíku" — URL detailu produktu, který se přidává
let advancedOrderSourceUrl = null;

// Cache per URL detailu: Promise s polem { href, html } (jen úspěšné načtení)
const advancedOrderRelatedCache = {};

function advancedOrderRelatedEnabled() {
    const config = window.shopDataLayer && window.shopDataLayer.advancedOrderRelated;
    return !config || config.enabled !== false;
}

// "/zidle/x/?variant=1#a" i "https://www.zidlestoly.cz/zidle/x/" → "/zidle/x/"
function normalizeProductPath(href) {
    if (!href) {
        return null;
    }
    try {
        return new URL(href, window.location.origin).pathname;
    } catch (e) {
        return null;
    }
}

function productCardPath(card) {
    const link = card.querySelector("a.image[href], a.name[href]");
    return link ? normalizeProductPath(link.getAttribute("href")) : null;
}

// Z prvku formuláře zjistí URL produktu: karta → odkaz karty, jinak hlavní formulář detailu
function resolveSourceUrl(element) {
    const card = element.closest(".product");
    if (card) {
        return productCardPath(card);
    }

    if (element.closest("#product-detail-form") && getShoptetDataLayer().pageType === "productDetail") {
        const canonical = document.querySelector("link[rel='canonical']");
        return normalizeProductPath(canonical ? canonical.getAttribute("href") : window.location.pathname);
    }

    return null;
}

// Capture fáze — zapíše se dřív, než Shoptetí delegovaný handler formulář odešle přes AJAX
document.addEventListener("submit", function (e) {
    const form = e.target;
    if (!form || !form.matches || !form.matches("form.pr-action, form.variant-submit")) {
        return;
    }
    advancedOrderSourceUrl = resolveSourceUrl(form);
}, true);

// Karta z detailu → stejná podoba jako karta, kterou vrací Shoptet do pop-upu
function convertDetailCard(card) {
    card.classList.remove("col-sm-6", "col-md-12", "col-lg-6", "inactive");
    card.classList.add("active");

    card.querySelectorAll("img[data-src]").forEach(function (img) {
        img.setAttribute("src", img.getAttribute("data-src").trim());
        img.removeAttribute("data-src");
        img.setAttribute("loading", "lazy");
    });

    card.querySelectorAll(".p-bottom.no-buttons").forEach(function (bottom) {
        bottom.classList.remove("no-buttons");
        bottom.classList.add("single-button");
    });

    return card;
}

function loadRelatedProducts(url) {
    if (advancedOrderRelatedCache[url]) {
        return advancedOrderRelatedCache[url];
    }

    advancedOrderRelatedCache[url] = new Promise(function (resolve, reject) {
        $.get(url, function (data) {
            // DOMParser místo $.parseHTML — neinertní dokument, nestahuje obrázky celé stránky detailu
            const doc = new DOMParser().parseFromString(data, "text/html");
            const products = [];

            $(doc).find(".products-related .product").each(function () {
                const href = productCardPath(this);
                if (href) {
                    products.push({ href: href, html: convertDetailCard(this).outerHTML });
                }
            });

            resolve(products);
        }, "html").fail(function () {
            // Chyba se necachuje — příští přidání zkusí načíst znovu
            delete advancedOrderRelatedCache[url];
            reject();
        });
    });

    return advancedOrderRelatedCache[url];
}

function appendRelatedProducts(popup, products) {
    // Mezitím se pop-up zavřel nebo přepsal jiným přidáním
    if (!document.body.contains(popup)) {
        return;
    }

    const swiperEl = popup.querySelector(".advanced-order-swiper");
    const swiper = swiperEl ? swiperEl.swiper : null;
    const wrapper = popup.querySelector(".products-block.swiper-wrapper");
    if (!swiper || !wrapper) {
        return;
    }

    const existing = [];
    wrapper.querySelectorAll(".product").forEach(function (card) {
        existing.push(productCardPath(card));
    });

    // Pojistka proti záměně produktu: karty v pop-upu musí být mezi souvisejícími z detailu
    const detailHrefs = products.map(function (product) {
        return product.href;
    });
    const matches = existing.every(function (href) {
        return detailHrefs.indexOf(href) !== -1;
    });
    if (!matches) {
        return;
    }

    const slides = [];
    products.forEach(function (product) {
        if (existing.indexOf(product.href) !== -1) {
            return;
        }
        existing.push(product.href);

        const $card = $($.parseHTML(product.html.trim())).filter(".product");
        $card.addClass("swiper-slide");
        slides.push($card.get(0));
    });

    if (slides.length === 0) {
        return;
    }

    swiper.appendSlide(slides);

    if (typeof shoptet !== "undefined" && shoptet.csrf && shoptet.csrf.enabled) {
        slides.forEach(function (slide) {
            slide.querySelectorAll("form").forEach(function (form) {
                shoptet.csrf.injectToken(form);
            });
        });
    }

    window.initProductCards(".advanced-order");

    if (typeof window.initTooltips === "function") {
        window.initTooltips();
    }

    swiper.update();

    if (typeof shoptet !== "undefined" && shoptet.modal && shoptet.modal.resize) {
        shoptet.modal.resize();
    }
}

// Swiper v pop-upu zakládá main.js ve stejném eventu (bundle je abecedně, tento soubor je dřív)
function waitForAdvancedOrderSwiper(popup, callback, attempt) {
    const swiperEl = popup.querySelector(".advanced-order-swiper");
    if (swiperEl && swiperEl.swiper) {
        callback();
        return;
    }
    if ((attempt || 0) >= 20 || !document.body.contains(popup)) {
        return;
    }
    setTimeout(function () {
        waitForAdvancedOrderSwiper(popup, callback, (attempt || 0) + 1);
    }, 50);
}

document.addEventListener("ShoptetDOMAdvancedOrderLoaded", function () {
    const url = advancedOrderSourceUrl;
    advancedOrderSourceUrl = null;

    if (!advancedOrderRelatedEnabled() || !url) {
        return;
    }

    const popup = document.querySelector(".advanced-order");
    if (!popup || popup.hasAttribute("data-related-extended") || !popup.querySelector(".products-block .product")) {
        return;
    }
    popup.setAttribute("data-related-extended", "");

    loadRelatedProducts(url).then(function (products) {
        waitForAdvancedOrderSwiper(popup, function () {
            appendRelatedProducts(popup, products);
        });
    }, function () {});
});
